import './_config'
import './SPRINTA/__autoload'
import './translate.config.js'

import axios from 'axios'
import queryString from 'query-string'
import store from './store'
import { is_out } from './modules/actions/Login'
import T from './SPRINTA/translate/T'

import { setGmak } from './v2SPRINTA/third-party/Gmaps/Core'


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

T.handleUpdate(language => {
    if(store.getState().login.isLogged) {
        axios.post(`users/update_language`, {
            language
        })
    }

})

axios.defaults.baseURL = window.URL_API


function languageSet(request) {
    request.headers.Language = T.getLanguage()
    return request
}

T.handleUpdate(() => {
    axios.interceptors.request.use(languageSet)
})

axios.interceptors.request.use(languageSet)

function requestInterceptor(request) {
    request.headers.Auth = getCookie('authorization')
    if(store.getState().login.authorization)
        request.headers.Auth = store.getState().login.authorization

    if (request.data && request.data.constructor === FormData) {
        request.headers['Content-Type'] = 'multipart/form-data'
    }

    if (request.data && request.data.constructor === Object) {
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        request.data = queryString.stringify(request.data)
    }
    return request
}

function successInterceptor(response) {
    if(response.data && response.data.errors && response.data.errors[0]) {
        if(response.data.errors[0].parameter_name === 'Authorization') {
            store.dispatch(is_out())
        }
    }

    return response.data
}

function errorInterceptor(error) {
    console.log("Error:")
    console.error(error)
}

axios.interceptors
    .request.use(requestInterceptor)



axios.interceptors
    .response
    .use(successInterceptor, errorInterceptor)

setGmak(window.gmak)

export const successInterceptorAction = successInterceptor
export const errorInterceptorAction = errorInterceptor
export const getCookieAction = getCookie


// WEBPACK FOOTER //
// ./src/config.js